<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_751)">
    <rect
      x="5.48271"
      y="5.9827"
      width="14.0346"
      height="14.0346"
      rx="7.0173"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-miterlimit="10"
    />
    <rect
      x="2.7"
      y="3.18291"
      width="19.6342"
      height="19.6342"
      rx="9.81709"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-miterlimit="10"
    />
    <path
      d="M10.0047 16.7442C9.97128 16.7442 9.94116 16.7442 9.91363 16.7441C9.90513 16.7179 9.89591 16.6892 9.88569 16.6574L8.32584 11.8036C8.31574 11.7722 8.30664 11.7439 8.29839 11.718C8.32026 11.7018 8.34424 11.6842 8.37085 11.6646L12.4431 8.67337C12.4702 8.65345 12.4947 8.63548 12.5171 8.61911C12.5395 8.63548 12.564 8.65345 12.5911 8.67337L16.6633 11.6646C16.6899 11.6842 16.7139 11.7018 16.7358 11.718C16.7275 11.7439 16.7184 11.7722 16.7083 11.8036L17.5414 12.0713L16.7083 11.8036L15.1485 16.6574C15.1383 16.6892 15.129 16.7179 15.1206 16.7441C15.093 16.7442 15.0629 16.7442 15.0295 16.7442H10.0047Z"
      stroke="currentColor"
      stroke-width="1.75"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_751">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
